import * as React from 'react';
import { useMediaQuery, Theme, TableBody, TableCell } from '@mui/material';
import { Datagrid, DatagridProps, DatagridRow, Labeled, useTranslate, useListContext } from 'react-admin';

const SmallScreenDatagridBody: React.FC<DatagridProps> = (props) => {
  const { data = [], children, ...rest } = props;
  const { selectedIds, onToggleItem } = useListContext(); // リストコンテキストから選択管理機能を取得

  return (
    <TableBody>
      {data.map((record, rowIndex) => (
        <DatagridRow
          key={record.id ?? `row${rowIndex}`}
          id={record.id ?? `row${rowIndex}`}
          record={record}
          selected={selectedIds.includes(record.id)} // 選択されているかどうか
          onToggleItem={() => onToggleItem(record.id)} // 選択トグル機能
          {...(rest as any)}
        >
          <TableCell
            sx={{
              display: 'block',
              padding: '16px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              margin: '8px 0'
            }}
          >
            {React.Children.toArray(children).map((field, index) =>
              field && React.isValidElement<any>(field) ? (
                <div key={index} style={{ marginBottom: '8px' }}>
                  <Labeled key={field.props.source}>{field}</Labeled>
                </div>
              ) : null
            )}
          </TableCell>
        </DatagridRow>
      ))}
    </TableBody>
  );
};

const FlexibleListLayout: React.FC<DatagridProps> = (props) => {
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const { sx: externalSx, ...rest } = props;
  return (
    <Datagrid
      {...rest} // <-- sx を含まない残りの props を渡す
      sx={{
        // 1. 内部のデフォルトスタイルを先に定義
        ...(isSmall ? { '& thead': { display: 'none' } } : {}),
        '& td': {
          padding: isSmall ? '0 0' : '12px 16px',
          borderBottom: isSmall ? 'none' : '1px solid #ccc'
        },
        '& th': {
          padding: '12px 16px',
          whiteSpace: 'nowrap'
        },
        '& td > td': {
          padding: '16px',
          borderBottom: '1px solid #ccc'
        },

        // 外部の sx (externalSx) を "最後" に適用
        ...externalSx
      }}
      body={isSmall ? <SmallScreenDatagridBody {...props} /> : undefined}
    />
  );
};

export default FlexibleListLayout;
